import React from 'react'
import TopBar from '../components/header/TopBar'
import HeaderOne from '../components/header/HeaderOne'
import BlogDetailsMain from '../components/blog/BlogDetailsMain'

function BlogDetails() {
  return (
    <div>
        <TopBar />
        <HeaderOne />
        <BlogDetailsMain />
    </div>
  )
}

export default BlogDetails